export default __webpack_public_path__ + "images/d354dabc7ed80f4dfd264d3af900ca4c.png";